class ESignUp {
  amzSDK: any;
  lambdaPayload: any;
  dialogObj: DialogObj;
  lbHideParams: Array<string>;
  cookieValue: string;
  elementIDs: ElementIDs;
  lambdaClient: any;
  addedToSalesforceTime: any;
  updatedOnSalesforceTime: any;

  constructor({
    amzSDK,
    lambdaPayload,
    dialogObj,
    lbHideParams,
    cookieValue,
    elementIDs,
  }: ESignUpOptions) {

    if (!amzSDK) 
      throw new Error('"amzSDK" config value is required.');

    if (!lambdaPayload)
      throw new Error('"lambdaPayload" config value is required.');

    if (!dialogObj) 
      throw new Error('"dialogObj" config value is required.');

    const defaultLambdaPayload = {
      region: "US",
      timeZone: "-5",
      language: "EN",
      method: "API",
    };

    const defaultElementIds = {
      lightBoxInput: "#emailAddress1",
      lightBoxBtn: "#emailAddress1btn",
      footerInput: "#emailAddress2",
      footerBtn: "#emailAddress2btn",
      homePageInput: "#emailAddress3",
      homePageBtn: "#emailAddress3btn",
      lightBoxBackground: "#emailSignupPopover",
      lightBoxCloseBtn: "#ligtboxClosebtn",
      sweepsBtn: "#sweepsBtn",
      sweepsEmail: "#sweepsEmail",
      sweepsName: "#sweepsName",
      sweepsCheck: "#sweepsCheck",
      sweepsBonvoyCheck: "#sweepsBonvoyCheck",
      landingPageSweepsBtn: "#landingPageSweepsBtn",
      landingPageSweepsEmail: "#landingPageSweepsEmail",
      landingPageSweepsName: "#landingPageSweepsName",
      landingPageSweepsBonvoyCheck: "#landingPageSweepsBonvoyCheck",
      landingPageSweepsCheck: "#landingPageSweepsCheck",
      checkoutPageEmailInput: '#emailAddress',
      checkoutPageSubscribeCheck: '#emailSubscribe'
    };

    const defaultDialogObj = {
      btnTxt: "OK",
    };

    this.amzSDK = amzSDK;

    this.lambdaPayload = {
      ...defaultLambdaPayload,
      ...lambdaPayload,
    };

    this.dialogObj = {
      ...defaultDialogObj,
      ...dialogObj,
    };

    this.lbHideParams = lbHideParams || ["utm_source=hah"];

    this.cookieValue = cookieValue || "emailSignup";

    this.elementIDs = {
      ...defaultElementIds,
      ...elementIDs,
    };
    
    this.addedToSalesforceTime = {}
    this.updatedOnSalesforceTime = {}

    this.lambdaClient = this.initLambdaClient();
  }

  /**
   * Initializes the AWS SDK and returns the client to interact with AWS.
   */
  initLambdaClient() {
    AWS.config.region = this.amzSDK.region;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: this.amzSDK.poolId,
    });
    AWS.config.apiVersions = {
      lambda: "2015-03-31",
    };
    AWS.config.update({
      maxRetries: 0,
      httpOptions: {
        timeout: 5000,
        connectTimeout: 5000,
      },
    });
    return new AWS.Lambda();
  }

  getTimeZone() {
    let currDate = new Date();
    return Math.floor((currDate.getTimezoneOffset() / 60) * -1).toString();
  }

  hideLandingPageSweepsForm() {
    $("#sweepstakesFormWrap").fadeOut("slow", function () {
      $("#sweepstakesConfirmation").fadeIn("slow");
    });
  }

  /**
   * Calls AWS Lambda to subscribe/unsubscribe a client email.
   */
  callLambda({
    email,
    source,
    action,
    showLightboxMessage = false,
    name = "",
    campaign = undefined,
    callback = undefined
  }: LambdaOptions) {

    // Hides the lightbox
    this.showLightbox(false);

    // Show the "thank you for subscribing" lightbox 
    if (showLightboxMessage) {
      dilogBox(this.dialogObj);
      window.scrollTo(0, 0);
    }

    const payload = {
      emailId: email,
      source: source,
      timeZone: this.getTimeZone(),
      name: name,
      campaign: campaign,
    };

    const lambdaPayload = {
      action: action,
      data: {
        ...this.lambdaPayload,
        ...payload,
      },
    };

    const params = {
      FunctionName: this.amzSDK.functionName,
      Payload: JSON.stringify(lambdaPayload),
    };

    this.lambdaClient.invoke(params, function (err: any, data: any) {
      if (callback) callback(err, data);
    });
  }

  checkQueryVariables() {
    let vars = window.location.search.substring(1).toLowerCase().split("&");
    let paramsPresent = false;
    for (let i = 0; i < this.lbHideParams.length; i++) {
      if (vars.indexOf(this.lbHideParams[i]) > -1) {
        paramsPresent = true;
      }
    }
    return paramsPresent;
  }

  checkDisplayLightbox() {
    let emailCookie = getCookie(this.cookieValue);
    if (emailCookie === null) {
      let paramsPresent = false;
      paramsPresent = this.checkQueryVariables();
      if (paramsPresent) {
        this.showLightbox(false);
      } else {
        this.showLightbox(true);
      }
    }
  }

  showLightbox(show = false) {
    let emailSignupPopoverDiv = document.getElementById("emailSignupPopover");
    if (show) {
      if (emailSignupPopoverDiv) {
        emailSignupPopoverDiv.style.display = "";
        HAHAccessibility.trapFocus({
          container: '.emailFocusTrap', 
          closeElement: '#emailSignupPopover'
        });
      }
    } else {
      if (emailSignupPopoverDiv) {
        emailSignupPopoverDiv.style.display = "none";
      }
      setCookie(this.cookieValue, "emailClosed", 180);
    }
  }

  validateSweeps(name, emailID, checked, recaptchaPassed) {
    let alertMessage = "";
    let nameRegex = /^[a-z ,.'-]+$/i;

    if (!nameRegex.test(name)) alertMessage += "Please enter a valid name. \n";
    if (!validateEmail(emailID))
      alertMessage += "Please enter a valid email address.\n";
    if (!checked) alertMessage += "Please check the sweeps rules checkbox.\n";
    /* if (!recaptchaPassed) {
      alertMessage += "Please complete re-captcha.";
    } */
    if (alertMessage !== "") {
      alert(alertMessage);
      return false;
    }
    return true;
  }

  async toggleEmailStatusInSalesforce(
    email: string, 
    emailStatus: 'Active' | 'Unsubscribed' | 'EmailID does not exist.', 
    agreeToReceiveEmails: boolean
  ) {

    if (email) {

      // saves the email in the session storage so it can track the cart again in the payment page
      sessionStorage.setItem('emailAddress', email)

      SalesforceAbandonedCartUtils.setClientEmail(email)
      SalesforceAbandonedCartUtils.trackCart();

      // if email is not in Salesforce
      if (emailStatus.includes('does not exist')) {

        // add to Salesforce and set as "Active"
        const isActive: boolean = await new Promise<boolean>((resolve) => {
          this.callLambda({
            email: email,
            source: 'checkout',
            showLightboxMessage: false,
            action: 'add',
            callback: (err: any, data: any) => {

              if (err) {
                console.log(err)
              }

              if (data) {

                // uncomment if troubleshooting and comment again before commit
                // console.log({...data, Payload: JSON.parse(data.Payload)})
  
                if (data.StatusCode == 200) {  
                  resolve(true)
                } else {
                  resolve(false)
                }
              }
            }
          })
        });

        // save the date it was added to Salesforce
        this.addedToSalesforceTime[email] = new Date()

        // if agree to receive emails (checkbox checked)
        if (agreeToReceiveEmails) {

          // if successfully set as "Active", send "Subscribe" event to Google Analytics
          if (isActive) {
            dataLayer.push({
              event: 'eNews Subscription',
              event_category: 'eNews Subscription',
              event_action: 'Subscribe',
              event_label: 'checkout',
              event_value: 1,
            });
          }
        } 
        
        // if doesn't agree to receive emails (checkbox unchecked)
        else {

          // update status in Salesforce to "Unsubscribed"
          const isUnsubscribed: boolean = await new Promise<boolean>((resolve) => {
            this.callLambda({
              email: email,
              source: 'checkout',
              showLightboxMessage: false,
              action: 'remove',
              callback: (err: any, data: any) => {

                if (err) {
                  console.log(err)
                }

                if (data) {

                  // uncomment if troubleshooting and comment again before commit
                  // console.log({...data, Payload: JSON.parse(data.Payload)})
    
                  if (data.StatusCode == 200) {
    
                    let isUnsubscribed: boolean = false
                    try {
                      if (data.Payload) {
                        isUnsubscribed = JSON.parse(data.Payload).values.status.toLowerCase() === 'unsubscribed';
                      }
                    } catch {
                      if (data.Payload) {
                        isUnsubscribed = data.Payload.toLowerCase().includes('unsubscribed') 
                      }
                    }
    
                    resolve(isUnsubscribed)
                  }
                }
              }
            })
          })

          // if successfully set as "Unsubscribed", send "Unsubscribe" event to Google Analytics
          if (isUnsubscribed) {
            dataLayer.push({
              event: 'eNews Subscription',
              event_category: 'eNews Subscription',
              event_action: 'Unsubscribe',
              event_label: 'checkout',
              event_value: 1,
            });
          }
        }
      }

      // if email is already in Salesforce
      else {

        // if does not agree to receive emails (is "Unsubscribed" in Salesforce)
        if (emailStatus.includes('Unsubscribed')) {

          // if agree to receive emails (checkbox checked)
          if (agreeToReceiveEmails) {

            // save the date it was updated in salesforce
            if (!this.updatedOnSalesforceTime[email]) {
              this.updatedOnSalesforceTime[email] = new Date()
            }

            // updates status in Salesforce to "Active" 
            const isActive = await new Promise((resolve) => {
              this.callLambda({
                email: email,
                source: 'checkout',
                showLightboxMessage: false,
                action: 'add',
                callback: (err: any, data: any) => {

                  if (err) {
                    console.log(err)
                  }
                  
                  if (data) {

                    // uncomment if troubleshooting and comment again before commit
                    // console.log({...data, Payload: JSON.parse(data.Payload)})

                    if (data.StatusCode == 200) {

                      let isActive: boolean
                      try {
                        isActive = JSON.parse(data.Payload).values.status.toLowerCase() === 'active';
                      } catch {
                        isActive = data.Payload.toLowerCase().includes('active')
                      }

                      resolve(isActive)
                    }
                  }
                }
              })
            })

            // if successfully set as "Active", send "Subscribe" event to Google Analytics
            if (isActive) {
              dataLayer.push({
                event: 'eNews Subscription',
                event_category: 'eNews Subscription',
                event_action: 'Subscribe',
                event_label: 'checkout',
                event_value: 1,
              });
            }
          }
        }

        // if agrees to receive emails (is "Active" in Salesforce)
        else {

          // if doesn't agree to receive emails (checkbox unchecked)
          if (!agreeToReceiveEmails) {

            const dateInserted: Date = this.addedToSalesforceTime[email]
            const dateUpdated: Date = this.updatedOnSalesforceTime[email]

            // if was just inserted or updated in Salesforce
            if (dateInserted || dateUpdated) {
              
              const now = new Date();
              const diffInMilliseconds = Math.abs(now.getTime() - (dateInserted ?? dateUpdated).getTime());
              const diffInMinutes = diffInMilliseconds / (1000 * 60)

              // if was added or updated less than 5 minutes ago
              if (diffInMinutes < 5) {

                // update status in Salesforce to "Unsubscribed"
                const isUnsubscribed: boolean = await new Promise<boolean>((resolve) => {
                  this.callLambda({
                    email: email,
                    source: 'checkout',
                    showLightboxMessage: false,
                    action: 'remove',
                    callback: (err: any, data: any) => {
  
                      if (err) {
                        console.log(err)
                      }
  
                      if (data) {
  
                        // uncomment if troubleshooting and comment again before commit
                        // console.log({...data, Payload: JSON.parse(data.Payload)})
          
                        if (data.StatusCode == 200) {
          
                          let isUnsubscribed: boolean = false
                          try {
                            if (data.Payload) {
                              isUnsubscribed = JSON.parse(data.Payload).values.status.toLowerCase() === 'unsubscribed';
                            }
                          } catch {
                            if (data.Payload) {
                              isUnsubscribed = data.Payload.toLowerCase().includes('unsubscribed') 
                            }
                          }
          
                          resolve(isUnsubscribed)
                        }
                      }
                    }
                  })
                })
  
                // if successfully set as "Unsubscribed", send "Unsubscribe" event to Google Analytics
                if (isUnsubscribed) {
                  dataLayer.push({
                    event: 'eNews Subscription',
                    event_category: 'eNews Subscription',
                    event_action: 'Unsubscribe',
                    event_label: 'checkout',
                    event_value: 1,
                  });
                }
              }
            }
          }
        }
      }
    }
  }

  bindElementHandlers() {

    const footerBtn = $(this.elementIDs.footerBtn);
    const lightBoxBtn = $(this.elementIDs.lightBoxBtn);
    const homePageBtn = $(this.elementIDs.homePageBtn);
    const lightBoxCloseBtn = $(this.elementIDs.lightBoxCloseBtn);
    const lightBoxBackground = $(this.elementIDs.lightBoxBackground);
    const sweepsBtn = $(this.elementIDs.sweepsBtn);
    const landingPageSweepsBtn = $(this.elementIDs.landingPageSweepsBtn);
    const checkoutPageEmailInput = $(this.elementIDs.checkoutPageEmailInput);
    const checkoutPageSubscribeCheckbox = $(this.elementIDs.checkoutPageSubscribeCheck);

    if (lightBoxCloseBtn.length) {
      lightBoxCloseBtn.on("click", () => {
        this.showLightbox(false);
      });
    }

    if (lightBoxBackground.length) {
      $(document).on("click", (e) => {
        if ($(e.target).is(lightBoxBackground)) {
          this.showLightbox(false);
        }
      });
    }

    if (lightBoxBtn.length) {
      lightBoxBtn.on("click", () => {
        let emailValue = (<any>$(this.elementIDs.lightBoxInput).val()).trim();
        if (!validateEmail(emailValue)) {
          alert("Please enter a valid email address.");
        } else {
          this.callLambda({
            email: emailValue, 
            source: "lightbox", 
            showLightboxMessage: true,
            action: 'add'
          });
          setCookie("HAHemailID", emailValue, 180);
          dataLayer.push({
            event: "eNews Subscription",
            event_category: "eNews Subscription",
            event_action: "Subscribe",
            event_label: "lightbox",
            event_value: 1,
          });
          SalesforceAbandonedCartUtils.setClientEmail(emailValue)
        }
      });
    }

    if (homePageBtn.length) {
      homePageBtn.on("click", () => {
        let emailValue = (<any>$(this.elementIDs.homePageInput).val()).trim();
        if (!validateEmail(emailValue)) {
          alert("Please enter a valid email address.");
        } else {
          this.callLambda({
            email: emailValue, 
            source: "home", 
            showLightboxMessage: false,
            action: 'add'
          });
          setCookie("HAHemailID", emailValue, 180);
          $("#ftr-email-signup").fadeOut("slow", function () {
            $("#ftr-email-conf").fadeIn("slow");
          });
          dataLayer.push({
            event: "eNews Subscription",
            event_category: "eNews Subscription",
            event_action: "Subscribe",
            event_label: "home",
            event_value: 1,
          });
          SalesforceAbandonedCartUtils.setClientEmail(emailValue)
        }
      });
    }

    if (sweepsBtn.length) {
      sweepsBtn.on("click", () => {
        let sweepsEmail = (<any>$(this.elementIDs.sweepsEmail).val()).trim();
        let sweepsName = (<any>$(this.elementIDs.sweepsName).val()).trim();
        let sweepsChecked = $(this.elementIDs.sweepsCheck).is(":checked");

        let campaign = '202407';
        if (this.validateSweeps(sweepsName, sweepsEmail, sweepsChecked, 1)) {
          this.callLambda({
            email: sweepsEmail,
            source: "lightbox",
            showLightboxMessage: true,
            action: "sweepsadd",
            name: sweepsName,
            campaign: campaign
          });
          setCookie("HAHemailID", sweepsEmail, 180);
          dataLayer.push({
            event: "eNews Subscription",
            event_category: "eNews Subscription",
            event_action: "Subscribe",
            event_label: "sweeps",
            event_value: 1,
          });
          SalesforceAbandonedCartUtils.setClientEmail(sweepsEmail)
        }
      });
    }

    if (landingPageSweepsBtn.length) {
      landingPageSweepsBtn.on("click", () => {
        let landingPageSweepsEmail = (<any>$(this.elementIDs.landingPageSweepsEmail)
          .val())
          .trim();
        let landingPageSweepsName = (<any>$(this.elementIDs.landingPageSweepsName)
          .val())
          .trim();
        let landingPageSweepsChecked = $(
          this.elementIDs.landingPageSweepsCheck
        ).is(":checked");
        let landingPageSweepsBonvoyChecked = $(
          this.elementIDs.landingPageSweepsBonvoyCheck
        ).is(":checked");
        let v = '';  //grecaptcha.getResponse();
        let campaign = "202407";
        if (
          this.validateSweeps(
            landingPageSweepsName,
            landingPageSweepsEmail,
            landingPageSweepsChecked,
            v.length
          )
        ) {
          this.callLambda({
            email: landingPageSweepsEmail,
            source: "sweeps",
            showLightboxMessage: true,
            action: "sweepsadd",
            name: landingPageSweepsName,
            campaign: campaign,
            callback: this.hideLandingPageSweepsForm,
          });
          setCookie("HAHemailID", landingPageSweepsEmail, 180);
          dataLayer.push({
            event: "eNews Subscription",
            event_category: "eNews Subscription",
            event_action: "Subscribe",
            event_label: "sweeps landing page",
            event_value: 1,
          });
          SalesforceAbandonedCartUtils.setClientEmail(landingPageSweepsEmail)
        }
      });
    }

    if (footerBtn.length) {
      footerBtn.on("click", () => {
        let emailValue = (<any>$(this.elementIDs.footerInput).val()).trim();
        if (!validateEmail(emailValue)) {
          alert("Please enter a valid email address.");
        } else {
          this.callLambda({
            email: emailValue, 
            source: "footer", 
            showLightboxMessage: false,
            action: 'add'
          });
          setCookie("HAHemailID", emailValue, 180);
          $("#ftr-email-signup2").fadeOut("slow", function () {
            $("#ftr-email-conf2").fadeIn("slow");
          });
          dataLayer.push({
            event: "eNews Subscription",
            event_category: "eNews Subscription",
            event_action: "Subscribe",
            event_label: "footer",
            event_value: 1,
          });
          SalesforceAbandonedCartUtils.setClientEmail(emailValue)
          SalesforceAbandonedCartUtils.trackCart()
        }
      });
    }

    if (checkoutPageEmailInput.length  && checkoutPageSubscribeCheckbox.length) {
      checkoutPageEmailInput.on('change', async (event) => {

        const email = (event.target as HTMLInputElement).value ||
                       sessionStorage.getItem('emailAddress') ||
                       getCookie('HAHemailID')

        const result: any = await new Promise((resolve, _reject) => {
          this.callLambda({
            email: email,
            source: 'checkout',
            showLightboxMessage: false,
            action: 'status',
            callback: (_err: any, data: any) => resolve(JSON.parse(data.Payload))
          })
        })

        const emailStatus = result
        const agreeToReceiveEmails = (document.querySelector(this.elementIDs.checkoutPageSubscribeCheck) as HTMLInputElement).checked

        this.toggleEmailStatusInSalesforce(email, emailStatus, agreeToReceiveEmails)
      })
    }

    if (checkoutPageSubscribeCheckbox.length) {
      checkoutPageSubscribeCheckbox.on('change', async (event) => {

        const email = (document.querySelector(this.elementIDs.checkoutPageEmailInput) as HTMLInputElement).value ||
                       sessionStorage.getItem('emailAddress') ||
                       getCookie('HAHemailID')

        const result: any = await new Promise((resolve) => {
          this.callLambda({
            email: email,
            source: 'checkout',
            showLightboxMessage: false,
            action: 'status',
            callback: (_err: any, data: any) => resolve(JSON.parse(data.Payload))
          })
        })

        const emailStatus = result
        const agreeToReceiveEmails = (event.target as HTMLInputElement).checked

        this.toggleEmailStatusInSalesforce(email, emailStatus, agreeToReceiveEmails)
      })
    }
  }
}

interface ESignUpOptions {

  /**
   * Values to be used in the initialization of the AWS SDK.
   */
  amzSDK: {
    region: string
    poolId: string
    functionName: string
  },

  /**
   * A piece of the payload that is sent to AWS Lambda to communicate with Salesforce.
   */
  lambdaPayload: {
    website: string,
    campaign: string,
    refURL: string,
    currURL: string
  },

  /**
   * Options for the lightbox that is shown in some situations.
   */
  dialogObj: {
    mainTxt: string,
    secondaryTxt: string,
    btnTxt: string
  },

  /**
   * Query parameters to be considered.
   */
  lbHideParams: Array<string>,

  /**
   * The name of the cookie to be used to store the client email status.
   */
  cookieValue: string,

  /**
   * HTML elements that are used in the process of subscribing a client email.
   */
  elementIDs: ElementIDs
}

interface LambdaOptions {

  /**
   * The email of the client.
   */
  email: string

  /**
   * The page/component where the client sets the email.
   */
  source: string
  
  /**
   * The action to be done in the lambda function.
   */
  action: 'status' | 'add' | 'sweepsadd' | 'remove'

  /**
   * If true, the "thank you for subscribing" lightbox will be shown.
   */
  showLightboxMessage?: boolean

  /**
   * A name that identifies the promotion.
   * Normally it's the sweeps promotion name and it's defined by an HTML element content.
   */
  name?: string

  /**
   * Identifies the campaign if the subscription belongs to one.
   * It's normally used with sweeps promotions.
   */
  campaign?: string

  /**
   * A callback function to be called after the Lambda function request is done.
   */
  callback?: (err: any, data: any) => any
}

interface ElementIDs {
  lightBoxInput: string;
  lightBoxBtn: string;
  footerInput: string;
  footerBtn: string;
  homePageInput: string;
  homePageBtn: string;
  lightBoxBackground: string;
  lightBoxCloseBtn: string;
  sweepsBtn: string;
  sweepsEmail: string;
  sweepsName: string;
  sweepsCheck: string;
  sweepsBonvoyCheck: string;
  landingPageSweepsBtn: string;
  landingPageSweepsEmail: string;
  landingPageSweepsName: string;
  landingPageSweepsBonvoyCheck: string;
  landingPageSweepsCheck: string;
  checkoutPageEmailInput: string;
  checkoutPageSubscribeCheck: string;
}